module.exports = __webpack_public_path__ + "img/logo-dark.94d8eb30.png";